// src/pages/Public/CGV.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import {
  FiPackage,
  FiTruck,
  FiDollarSign,
  FiClock,
  FiShield,
  FiFileText,
  FiUsers,
  FiMapPin,
} from "react-icons/fi";

const CGV = () => {
  const sections = [
    {
      icon: FiFileText,
      title: "Article 1 - Objet",
      content:
        "Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre CAC - Chine Afrique Cargo et ses clients pour l'ensemble des prestations de transport et services logistiques proposés.",
    },
    {
      icon: FiPackage,
      title: "Article 2 - Prestations de services",
      content:
        "CAC propose les services suivants :\n• Transport aérien de marchandises\n• Transport maritime de marchandises\n• Dédouanement et formalités douanières\n• Livraison à domicile\n• Suivi de colis en temps réel\n• Assurance transport (optionnelle)",
    },
    {
      icon: FiDollarSign,
      title: "Article 3 - Tarifs et paiement",
      content:
        "Les tarifs sont établis sur devis et peuvent varier selon :\n• Le mode de transport choisi\n• Le poids et le volume de la marchandise\n• La destination\n• Les services optionnels souscrits\nLe paiement s'effectue selon les modalités indiquées sur le devis.",
    },
    {
      icon: FiClock,
      title: "Article 4 - Délais de livraison",
      content:
        "Les délais de livraison sont donnés à titre indicatif et ne sont pas garantis :\n• Transport aérien : 5 à 10 jours ouvrés\n• Transport maritime : 45 à 90 jours ouvrés\nLes retards éventuels ne donnent pas droit à des pénalités ou indemnités.",
    },
    {
      icon: FiShield,
      title: "Article 5 - Responsabilité et assurance",
      content:
        "CAC est responsable de la marchandise pendant le transport dans les limites prévues par la loi. Une assurance optionnelle peut être souscrite pour couvrir :\n• La perte totale ou partielle\n• Les dommages matériels\n• Le vol\nLes réserves doivent être formulées au moment de la réception.",
    },
    {
      icon: FiUsers,
      title: "Article 6 - Obligations du client",
      content:
        "Le client s'engage à :\n• Fournir des informations exactes sur la marchandise\n• Préparer les documents nécessaires à l'expédition\n• Respecter les délais de paiement\n• Ne pas expédier de marchandises interdites ou dangereuses",
    },
    {
      icon: FiMapPin,
      title: "Article 7 - Livraison et réception",
      content:
        "La livraison est effectuée à l'adresse indiquée par le client. En cas d'absence, un avis de passage est déposé et la marchandise peut être récupérée dans l'agence CAC la plus proche. Des frais de stockage peuvent s'appliquer au-delà de 48h.",
    },
    {
      icon: FiFileText,
      title: "Article 8 - Droit de rétractation",
      content:
        "Conformément à la réglementation, le client dispose d'un délai de 24h pour annuler sa commande. Passé ce délai, la marchandise est en cours de traitement et des frais d'annulation peuvent être facturés.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>CGV - Conditions Générales de Vente - CAC</title>
        <meta
          name="description"
          content="Consultez les Conditions Générales de Vente de CAC - Chine Afrique Cargo. Tarifs, délais, responsabilité, assurance et obligations du client."
        />
        <link rel="canonical" href={window.location.origin + "/cgv"} />
      </Helmet>

      <div className="cgv-page">
        <div className="cgv-hero">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={8}>
                <h1 className="cgv-hero-title">
                  📜 Conditions Générales de Vente
                </h1>
                <p className="cgv-hero-subtitle">
                  Les conditions qui régissent nos relations commerciales
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="cgv-container py-5">
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="cgv-intro">
                <p className="text-muted text-center mb-4">
                  Dernière mise à jour :{" "}
                  {new Date().toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
              </div>

              <div className="cgv-grid">
                {sections.map((section, index) => (
                  <div key={index} className="cgv-card">
                    <div className="cgv-card-icon">
                      <section.icon size={28} />
                    </div>
                    <div className="cgv-card-content">
                      <h3 className="cgv-card-title">{section.title}</h3>
                      {section.content.split("\n").map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="cgv-footer">
                <p className="text-center text-muted small">
                  Les présentes CGV annulent et remplacent toutes les versions
                  antérieures. En cas de litige, la version française fait foi.
                </p>
                <div className="text-center mt-3">
                  <a
                    href="/contact"
                    className="btn btn-danger px-4 py-2 rounded-pill"
                  >
                    📞 Une question ? Contactez-nous
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <style>{`
                    .cgv-page {
                        background: #f8f9fa;
                        min-height: 100vh;
                    }
                    
                    .cgv-hero {
                        background: linear-gradient(135deg, #0a0a2a 0%, #1a1a4e 50%, #0a0a2a 100%);
                        padding: 80px 0 60px;
                    }
                    
                    .cgv-hero-title {
                        font-size: 48px;
                        font-weight: 800;
                        color: white;
                        margin-bottom: 16px;
                    }
                    
                    .cgv-hero-subtitle {
                        font-size: 18px;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    
                    .cgv-grid {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                    }
                    
                    .cgv-card {
                        background: white;
                        border-radius: 12px;
                        padding: 20px 24px;
                        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
                        display: flex;
                        gap: 16px;
                        align-items: flex-start;
                        transition: all 0.3s ease;
                        border-left: 3px solid #C62828;
                    }
                    
                    .cgv-card:hover {
                        transform: translateX(4px);
                        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
                    }
                    
                    .cgv-card-icon {
                        min-width: 40px;
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                        background: rgba(198, 40, 40, 0.08);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #C62828;
                        font-size: 18px;
                    }
                    
                    .cgv-card-content {
                        flex: 1;
                    }
                    
                    .cgv-card-title {
                        font-size: 17px;
                        font-weight: 700;
                        color: #1a1a3e;
                        margin-bottom: 8px;
                    }
                    
                    .cgv-card-content p {
                        color: #555;
                        margin-bottom: 4px;
                        line-height: 1.6;
                    }
                    
                    .cgv-card-content p:last-child {
                        margin-bottom: 0;
                    }
                    
                    .cgv-footer {
                        margin-top: 30px;
                        padding: 30px;
                        background: white;
                        border-radius: 16px;
                        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
                    }
                    
                    @media (max-width: 992px) {
                        .cgv-hero-title {
                            font-size: 36px;
                        }
                    }
                    
                    @media (max-width: 768px) {
                        .cgv-hero-title {
                            font-size: 28px;
                        }
                        
                        .cgv-card {
                            padding: 16px 18px;
                            flex-direction: column;
                        }
                        
                        .cgv-card-icon {
                            min-width: 32px;
                            width: 32px;
                            height: 32px;
                        }
                    }
                `}</style>
      </div>
    </>
  );
};

export default CGV;
